import { useLocalParticipant } from "@livekit/components-react";
import clsx from "clsx";
import { Hand } from "lucide-react";
import * as React from "react";
import { useParticipantHandRaised, useRaiseHandContext } from "../utils/liveInterviewRaiseHand";

export function LiveInterviewReactionsPicker() {
  const { localParticipant } = useLocalParticipant();
  const raiseHandContext = useRaiseHandContext();
  const handRaised = useParticipantHandRaised(localParticipant);
  const [handBusy, setHandBusy] = React.useState(false);

  const handleToggle = async () => {
    if (!localParticipant || handBusy) return;
    setHandBusy(true);
    try {
      if (raiseHandContext?.toggleLocalHand) {
        await raiseHandContext.toggleLocalHand();
      }
    } finally {
      setHandBusy(false);
    }
  };

  const handTooltip = handRaised ? "Lower hand" : "Raise hand";

  return (
    <div className="li-reactions-wrap" data-tooltip={handTooltip}>
      <button
        type="button"
        className={clsx(
          "li-meet-bottom-more-btn",
          "li-reactions-trigger",
          handRaised && "has-hand-raised",
        )}
        aria-label={handTooltip}
        title={handTooltip}
        aria-pressed={handRaised}
        disabled={handBusy}
        onClick={() => void handleToggle()}
      >
        <Hand size={18} aria-hidden />
      </button>
    </div>
  );
}
